import { PermissionService } from '@abp/ng.core';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsDefinitionRowModel } from 'src/core/models/shared/settings-definition-row.model';
import { SettingsDefinitionModel } from 'src/core/models/shared/settings-definition.model';
import { FeatureService } from 'src/core/services/feature/feature.service';

@Component({
  selector: 'ca-setting-definitions',
  templateUrl: './setting-definitions.component.html',
  styleUrl: './setting-definitions.component.scss',
  standalone: false,
})
export class SettingDefinitionsComponent implements OnInit {
  @Input()
  items: SettingsDefinitionModel[] = [];

  @Input()
  information: string;

  rowItems: SettingsDefinitionRowModel[] = [];

  constructor(
    private router: Router,
    private permissionService: PermissionService,
    private featureService: FeatureService
  ) {}

  ngOnInit(): void {
    this.items?.forEach(x => {
      var havePermissions = true;
      var featuresEnabled = true;

      if (x.requiredPolicies && x.requiredPolicies.length > 0) {
        var havePermissions = false;

        x.requiredPolicies?.forEach(
          p => (havePermissions = havePermissions || this.permissionService.getGrantedPolicy(p))
        );
      }

      if (x.forFeatures && x.forFeatures.length > 0) {
        var featuresEnabled = false;

        x.forFeatures?.forEach(
          f => (featuresEnabled = featuresEnabled || this.featureService.isEnabled(f))
        );
      }

      this.rowItems.push({
        ...x,
        havePermissions: havePermissions,
        featuresEnabled: featuresEnabled,
      });
    });
  }

  navigateToDefinition(eventArgs, item: SettingsDefinitionModel): void {
    eventArgs.preventDefault();
    eventArgs.stopPropagation();

    if (eventArgs.which === 2) {
      if (item.extraData) {
        const url = this.router.serializeUrl(
          this.router.createUrlTree(item.navigationData, item.extraData)
        );
        window.open(url);
      } else {
        const url = this.router.serializeUrl(this.router.createUrlTree(item.navigationData));
        window.open(url);
      }
    } else if (eventArgs.which === 1) {
      if (item.extraData) {
        this.router.navigate(item.navigationData, item.extraData);
      } else {
        this.router.navigate(item.navigationData);
      }
    }
  }
}
